<template>
  <header>
    <b-navbar toggleable="lg">
      <b-navbar-brand class="logo" to="/">
        <img src="@/assets/static/images/logo.png" alt="" srcset="
            @/assets/static/images/logo@2x.png 2x,
            @/assets/static/images/logo@3x.png 3x
          " class="logo_high_resolution_white" />
      </b-navbar-brand>
      <div class="mobi nav-collapse-for-mobile ml-auto">
        <b-nav-item-dropdown @show="openProfleMenu()" right v-if="isLoggedIn">
          <!-- Using 'button-content' slot -->
          <template slot="button-content" class="btn user-btn" v-if="name.length > 15">
            <div class="avatar-menu">
              <img alt="avatar" :src="avatarUser" class="logo-avatar" @error="imageLoadError" />
            </div>
            <div class="user-name">
              {{ name | truncate(15, '...', 1) }}
              <em class="fas fa-angle-double-down"></em>
            </div>
          </template>
          <template slot="button-content" class="btn user-btn" v-else>
            <div class="avatar-menu">
              <img alt="avatar" :src="avatarUser" class="logo-avatar" @error="imageLoadError" />
            </div>
            <div class="user-name">
              {{ name }} <em class="fas fa-angle-double-down"></em>
            </div>
          </template>
          <b-dropdown-item @click="profile">PROFILE</b-dropdown-item>
          <b-dropdown-item @click="message">MESSAGES</b-dropdown-item>
          <b-dropdown-item @click="settings">SETTINGS</b-dropdown-item>
          <b-dropdown-item @click="goToBusinessAccount">BUSINESS ACCOUNT</b-dropdown-item>
          <b-dropdown-item @click="logout">LOGOUT</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-navbar-toggle target="nav-collapse-1" class="ml-auto id-js-button"></b-navbar-toggle>
      </div>
      <b-collapse id="nav-collapse-1" is-nav v-click-outside='clickOutSideMenu'>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <router-link :to="{ name: 'talents' }" class="nav-item d-flex align-items-center" tag="li" :activeClass="
            $route.path.includes('/talents')
              ? 'router-link-exact-active'
              : ''
          ">
            <span class="nav-link">BROWSE TALENT</span>
          </router-link>
          <router-link :to="{ name: 'jobs' }" class="nav-item d-flex align-items-center" tag="li" :activeClass="
            $route.path.includes('/jobs')
              ? 'router-link-exact-active'
              : ''
          ">
            <span class="nav-link">FIND WORK</span>
          </router-link>
          <router-link :to="{ name: 'post-job' }" class="nav-item d-flex align-items-center" tag="li">
            <span class="nav-link">POST A JOB</span>
          </router-link>
          <router-link :to="{ name: 'my-jobs' }" class="nav-item d-flex align-items-center" tag="li" :activeClass="
            $route.path.includes('/my-jobs')
              ? 'router-link-exact-active'
              : ''
          ">
            <span class="nav-link">MY JOBS</span>
          </router-link>
          <router-link :to="{ name: 'my-hires', query: {is_all: true} }" class="nav-item d-flex align-items-center"
            tag="li" :activeClass="
              $route.path.includes('/my-hires')
                ? 'router-link-exact-active'
                : ''
            ">
            <span class="nav-link">MY HIRES</span>
          </router-link>
          <router-link :to="{ name: 'e-wallet' , query:{ tab: 'overview', filter: 'all'} }"
            class="nav-item d-flex align-items-center" tag="li" :activeClass="
              $route.path.includes('/e-wallet')
                ? 'router-link-exact-active'
                : ''
            ">
            <span class="nav-link">MY E-WALLET</span>
          </router-link>
          <b-nav-item class="more-dropdown-link desktop" right>
            <div class="dropdown d-flex align-items-center" v-click-outside="clickOutSideShowMore">
              <button class="btn more-btn cursor-pointer pb-0" type="button" id="dropdownMenuButton"
                @click="isShowMore = !isShowMore" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                HELP <em class="fas fa-angle-double-down"></em>
              </button>
              <div class="dropdown-menu more-dropdown-menu" aria-labelledby="dropdownMenuButton"
                :class="{ 'd-block': isShowMore }">
                <router-link tag="a" class="dropdown-item about-us" :to="{ name: 'about-us' }">ABOUT US</router-link>
                <router-link tag="a" class="dropdown-item contact-us text-uppercase" :to="{ path: '/contact-us' }">
                  CONTACT US</router-link>
              </div>
            </div>
          </b-nav-item>
          <div class="mobi">
            <b-nav-item-dropdown center>
              <!-- Using 'button-content' slot -->
              <template slot="button-content" class="btn more-btn">HELP <em
                  class="fas fa-angle-double-down"></em></template>
              <b-dropdown-item href="/about-us">ABOUT US</b-dropdown-item>
              <b-dropdown-item href="/contact-us">CONTACT US</b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
          <div v-if="!isLoggedIn" class="profile-dropdown login">
            <b-nav-item :to="{ name: 'login' }" right class="d-flex align-items-center">LOG IN</b-nav-item>
            <b-nav-item :to="{ name: 'sign-up' }" right class="sign-up">
              SIGN UP
            </b-nav-item>
          </div>
          <div v-else class="profile-dropdown d-lg-flex d-md-block">
            <div right class="profile-link d-flex align-items-center" @click="showNotification($event)">
              <span class="notification-bell" ><em class="fas fa-bell"></em><span
                  v-if="numberNotification > 0" class="notification-number" @click="showNotification($event)">{{
                  numberNotification }}</span></span>
              <ListNotificationPopup class="d-none d-lg-block" v-if="isShowNotificationPopup"
                @hideNotificationPopup="hideNotificationPopup" />
            </div>
            <b-nav-item right @click="profile" class="avatar-link desktop">
              <div class="avatar-menu">
                <img alt="avatar" :src="avatarUser" class="logo-avatar" @error="imageLoadError" />
              </div>
            </b-nav-item>
            <b-nav-item class="profile-link desktop" right>
              <div class="dropdown user-profile-dropdown d-flex align-items-center"
                v-click-outside="clickOutSideShowProfile">
                <button v-if="nameUser.length > 15" class="btn user-btn cursor-pointer shadow-none"
                  @click="isShowProfile = !isShowProfile" :class="{ active: activeBtn === 'name-btn' }" type="button"
                  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ nameUser | truncate(15, '...', 1) }}
                  <em class="fas fa-angle-double-down"></em>
                </button>
                <button v-else class="btn user-btn cursor-pointer shadow-none user-name-padding"
                  @click="isShowProfile = !isShowProfile" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{ nameUser }} <em class="fas fa-angle-double-down"></em>
                </button>
                <div class="dropdown-menu user-profile" aria-labelledby="dropdownMenuButton"
                  :class="{'d-block': isShowProfile}">
                  <router-link tag="a" class="dropdown-item" :to="{
                    name: 'talent_profile',
                    params: { id: user.talent.talent_id }
                  }">PROFILE</router-link>
                  <a class="dropdown-item" @click="message">MESSAGES</a>
                  <a class="dropdown-item" @click="settings">SETTINGS</a>
                  <a class="dropdown-item" @click="goToBusinessAccount">BUSINESS ACCOUNT</a>
                  <a class="dropdown-item" @click="logout">LOGOUT</a>
                </div>
              </div>
            </b-nav-item>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <ListNotificationPopup class="d-block d-lg-none" v-if="isShowNotificationPopupMobile"
      @hideNotificationPopup="hideNotificationPopupMobile" />
  </header>
</template>
<script>
import defaultAvatar from '@/assets/static/images/avatar-default.svg'
import Common from '@/mixins/Common'
import ListNotificationPopup from '@/components/notifications/ListNotificationPopup'
import $bus from '@/_eventBus'
export default {
  name: 'SecondaryHeader',
  components: {
    ListNotificationPopup
  },
  data: () => {
    return {
      isActive: '',
      activeBtn: '',
      user: {},
      avatar: '',
      name: '',
      defaultAvatar,
      defaultName: 'Guest',
      isLoggedIn: false,
      numberNotification: null,
      isBlur: false,
      isShowNotificationPopup: false,
      notificationNumberTarget: null,
      isShowNotificationPopupMobile: false,
      notificationNumberTargetMobile: null,
      isShowMore: false,
      isShowProfile: false,
      isShowMenu: false
    }
  },
  mixins: [Common],
  created: function () {
    this.isLoggedIn = this.$store.getters.getAuthenticated
    if (this.isLoggedIn) {
      this.user = this.$store.getters.getUserInfo
    }
    this.avatar = this.user.avatar_url ? this.user.avatar_url : defaultAvatar
    this.name = this.user.first_name
      ? this.user.first_name
      : this.defaultName
    this.getNumberNotification()
    $bus.$on('pushNotification', (payload) => {
      if (payload === 0) {
        this.numberNotification = payload
      } else if (payload === -1) {
        this.numberNotification = this.numberNotification + payload
      } else {
        this.getNumberNotification()
      }
    })
  },
  computed: {
    nameUser() {
      let user = this.$store.getters.getUserInfo
      return user.first_name
        ? user.first_name
        : this.defaultName
    },
    avatarUser() {
      let user = this.$store.getters.getUserInfo
      return user.avatar_url ? user.avatar_url : defaultAvatar
    }
  },
  mounted: function () {
    let self = this
    window.addEventListener('focus', self.focusHandler)
    window.addEventListener('blur', self.blurHandler)
  },
  methods: {
    imageLoadError(event) {
      event.target.src = defaultAvatar
    },
    clickOutSideShowMore: function () {
      this.isShowMore = false
    },
    clickOutSideShowProfile: function () {
      this.isShowProfile = false
    },
    clickOutSideMenu(event) {
      if (event && event.target && event.target.className && (event.target.className.includes('id-js-button') || event.target.className.includes('navbar-toggler-icon'))) {
        return false
      }
      const elementHtml = document.getElementById('nav-collapse-1')
      if (elementHtml && elementHtml.classList.contains('show')) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse-1')
      }
    },
    toggleShowMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    logout: async function () {
      try {
        this.updateChatNotificationStatus()
        var element = document.createElement('iframe')
        element.style.display = 'none'
        element.setAttribute('src', 'https://www.google.com/accounts/Logout')
        document.body.appendChild(element)
        await this.$store.dispatch('removeTokenFirebase')
        await this.$store.dispatch('logout', this.$auth)
        this.$router.push('/')
        localStorage.clear()
        sessionStorage.clear()
      } catch (e) {
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push('/')
      } finally {
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push('/')
      }
    },
    updateChatNotificationStatus: function () {
      const params =
      {
        user_id: this.user.user_id,
        is_online: false,
        is_receive_chat: 'True'
      }
      this.$store.dispatch('updateOnlineOfflineStatus', params)
    },
    showNotification: function (event) {
      this.notificationNumberTarget = event.target
      this.notificationNumberTargetMobile = event.target
      event.preventDefault()
      this.isShowNotificationPopup = !this.isShowNotificationPopup
      this.isShowNotificationPopupMobile = !this.isShowNotificationPopupMobile
    },
    hideNotificationPopup: function (value) {
      if (!this.notificationNumberTarget) {
        this.isShowNotificationPopup = value
      }
      this.notificationNumberTarget = null
    },
    hideNotificationPopupMobile: function (value) {
      if (!this.notificationNumberTargetMobile) {
        this.isShowNotificationPopupMobile = value
      }
      this.notificationNumberTargetMobile = null
    },
    profile: function () {
      const path = '/talents/profile/' + this.user.talent.talent_id
      if (this.$route.path !== path) {
        this.$router.push({
          path: '/talents/profile/' + this.user.talent.talent_id
        })
      }
    },
    settings: function () {
      const path = '/settings'
      if (this.$route.path !== path) {
        this.$router.push('/settings')
      }
    },
    message: function () {
      const path = '/mesage'
      if (this.$route.path !== path) {
        this.$router.push('/message')
      }
    },
    goToBusinessAccount: function () {
      const path = '/business-account'
      if (this.$route.path !== path) {
        this.$router.push('/business-account')
      }
    },
    openProfleMenu: function () {
      this.isShowNotificationPopup = false
      this.isShowNotificationPopupMobile = false
      const elementHtml = document.getElementById('nav-collapse-1')
      if (elementHtml && elementHtml.classList.contains('show')) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse-1')
      }
    },
    getNumberNotification: async function () {
      await this.$store.dispatch('fetchNumberNotification')
      this.numberNotification = this.$store.getters.getNumberNotification
    },
    focusHandler: function () {
      if (this.isBlur) {
        this.isBlur = false
        this.getNumberNotification()
      }
    },
    blurHandler: function () {
      this.isBlur = true
    }
  },
  beforeDestroy: function () {
    let self = this
    $bus.$off('pushNotification')
    window.removeEventListener('focus', self.focusHandler)
    window.removeEventListener('blur', self.blurHandler)
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SecondaryHeader.vue